export const SWITCH_GRAPH_DATA_TYPE = 'SWITCH_GRAPH_DATA_TYPE';

const switchGraphDataType = (newGraphDataType) => ({
  type: SWITCH_GRAPH_DATA_TYPE,
  payload: newGraphDataType,
});

export default switchGraphDataType;
